import React, {useEffect} from 'react';
import { BackgroundHowWorks } from './style';
import {showNavBar} from "../../_store/_actions/uiActions";
import {useDispatch} from "react-redux";

const HowWorks = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(showNavBar());
    },[])

    return (
        <>
            <BackgroundHowWorks>
                <header id="header">
                    <div className="row col-md-12">
                        <div className="col-md-4">
                            <div className="title">
                                <h2>HOW IT WORKS?</h2>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="logo nomargin nopadding" />
                        </div>
                    </div>


                </header>

                <section id="content2">
                    <div className="content-wrap">
                        <div className="container-fluid">
                            <span className="t300 description">This product is based on rewards, the client can earn and enjoy the services offered by the platform.
                                Eco’s can be earned based upon a loyalty program that provides additional tokens for every room rental to others. This would be based upon volume per month.</span>
                            <br/> <br/>
                            <span className="t300 description">This program has other benefits as Eco Tokens, it can be transferred and never expire furthermore our Affiliates can make money to pay for their affiliation or to earn cash at home.</span>
                            <br/> <br/>
                            <span className="t400 contact">For more information contact our member partner representatives.</span>
                        </div>

                    </div>

                </section>



            </BackgroundHowWorks>
        </>
    );
};

export default HowWorks;
